import "./About.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import OurJourney from "./sections/OurJourney";
import ThePeopleBehindTheMission from "./sections/ThePeopleBehindTheMission";
import QualityMilestones from "./sections/QualityMilestones";
import EngineeringFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <PrimaryNavigation />
      <OurJourney />
      <ThePeopleBehindTheMission />
      <QualityMilestones />
      <EngineeringFooter />
    </div>;
}